import api from './api';
import {CHANNELS_SET_ACTIVE} from './channels';

export const MENUS_SET_MENU = 'MENUS_SET_MENU';

const initialState = {};

export default function reducer(state = initialState, {type, payload}) {
  switch (type) {
    case MENUS_SET_MENU:
      return {
        ...state,
        [payload.code]: payload.menu
      };
    case CHANNELS_SET_ACTIVE:
      return initialState;
    default:
      return state;
  }
}

export function setMenu(code, menu) {
  return {type: MENUS_SET_MENU, payload: {code, menu}};
}

export function fetchMenu(code) {
  return dispatch => {
    dispatch(setMenu(code, null));

    return dispatch(api.getAll(`menus/by-code/${code}/children`))
      .then(menuResponse => dispatch(setMenu(code, menuResponse.content.items)));
  };
}



// WEBPACK FOOTER //
// ./ducks/menus.js